<template>
  <div class="home w-100">
   

      <div v-if="windowWidth>974">
        <div class="first">
            <div class="row">
                <div class="col-6">
                  <!---------------------------User Register-------------------------------------->
                <transition v-if="registerShow" name="slide-fade">
                <div style="" class="row align-items-center justify-content-center h-100 text-center mt-5 login-modal"> 
                  <div style="padding-bottom:50px;" class="col-6 w-100 modal-content shadow mt-5">
                    <h3 class="mt-3 animated shake">Create Account</h3>
                    <form @submit.prevent="register" id="form-register" style="margin-top:30px;">
                      <div class="input-group mb-2"><!--Email Register-->
                        <div class="input-group-prepend">
                          <div class="input-group-text"><i class="far fa-envelope"></i></div>
                        </div>
                        <input class="form-control" name="email" type="email" placeholder="***@gafa.co.nz" id="email" >
                      </div>
                      <div class="input-group mb-2"><!--First Name Register-->
                        <div class="input-group-prepend">
                          <div class="input-group-text"><i class="fas fa-user"></i></div>
                        </div>
                        <input name="fname" class="form-control" type="text" placeholder="First Name" id="fname" >
                      </div>
                      <div class="input-group mb-2"><!--Last Name Register-->
                        <div class="input-group-prepend">
                          <div class="input-group-text"><i class="fas fa-user"></i></div>
                        </div>
                        <input name="lname" class="form-control" type="text" placeholder="Last Name" id="lname" >
                      </div>
                      <div class="input-group mb-2"><!--Password Register-->
                        <div class="input-group-prepend">
                          <div class="input-group-text"><i class="fas fa-key"></i></div>
                        </div>
                        <input class="form-control" name="password" 
                          type="password" id="password" 
                          placeholder="Password"
                          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" 
                          title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters" 
                          required
                          @focus="passFocus"
                          @blur="passBlur"
                          v-on:keyup="passkeyUp">
                      </div>
                      <div class="input-group mb-2"><!--Repeat Password Register-->
                        <div class="input-group-prepend">
                          <div class="input-group-text"><i class="fas fa-key"></i></div>
                        </div>
                        <input class="form-control" type="password" placeholder="Repeat Password" id="password2" >
                      </div>
                      <button  class="btn btn-primary circleButton btn-block" type="submit" name="log In">Sign In</button>
                      <p v-on:click="goLogin();" class="text-center">Account Already Created?<span> Go Login</span></p>
                    </form>
                  </div>
                </div>
                </transition>
                </div><!--Finish User Register-->
                <div class="col-6"><!--User Login-->
                <transition v-if="loginShow" name="slide-fade">
                    <div style="padding-top: 65px;" class="row align-items-center justify-content-center h-100 text-center mt-5 login-modal">
                      <div style="padding-bottom:50px;" class="col-6 w-100 modal-content shadow">
                        <div class="row align-items-center justify-content-center">
                          <img style="margin-top:-40px;" width="80px"  src="../assets/loginAvatar.png" alt="">
                        </div>
                        <h3 class="mt-3">Gafa Services</h3>
                        <form @submit.prevent="funcLogin(1)" id="formLoginLaptop" style="margin-top:30px;">
                          <div class="input-group mb-2"><!--Email Login-->
                            <div class="input-group-prepend">
                              <div class="input-group-text"><i class="fas fa-user"></i></div>
                            </div>
                            <input class="form-control" type="email" name="email" placeholder="Email Address">
                          </div>
                          <div class="input-group mb-2"><!--Password Login-->
                            <div class="input-group-prepend">
                              <div class="input-group-text"><i class="fas fa-key"></i></div>
                            </div>
                            <input class="form-control" name="password" type="password" placeholder="Password">
                          </div>
                          <p class="text-right">Forgot Password?</p>  
                          <button  class="btn btn-primary circleButton btn-block" type="submit" name="log In">Login</button>
                          <div class="text-center">
                            <p v-on:click="goRegister();!loginShow;!registerShow">No account?<span> Signup</span></p>
                          </div>                      
                        </form>                        
                      </div>                      
                    </div>
                </transition>
                </div><!--Finish User Login-->
            </div>
        </div>
        <div class="ontop" id="ontop">
            <div class="row align-items-center justify-content-center">
               
                <div class="col-12 aca" id="aca"> 
                   <div class="pruebacss">  
                                     
                   </div>
                </div>                
            </div>
        </div>
      </div>
      








    <!-------------------------------------------Login For Mobiles------------------------------------>
    <div v-else class='content row justify-content-center  minh-100'>
      <div class="col-sm-6 container-form mt-5">
        <form  @submit.prevent="funcLogin(0)" id="formLoginMobile" class="bodycontent text-center mt-5">
          <label  for="">Login here</label><br>          
          <div class="row align-items-center justify-content-center">
            <div class="col-10 col-md-6 margins">
              <label for=""><i class="fas fa-user"></i></label>
              <input class="form-control" type="email" name="email" placeholder="Enter User Email">
            </div>
            <div class="col-10 col-md-6 margins">
              <input class="form-control" name="password" type="password" placeholder="Enter Password">
            </div>
            <div class="col-10 col-sm-4 margins mt-3">
              <button class="btn btn-primary" type="submit" name="login">Login</button>
            </div>
          </div>

          <div class="pro">
            <a class="mr-2" href="#"><router-link to="/register">Register Now</router-link></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="forgotpassword.php"><router-link to="/home">Forgot Password?</router-link></a>
          </div>
        </form>
      </div>
    </div>
  </div>
  
</template>

<script>
// @ is an alias to /src
import {mapState,mapMutations, mapActions} from 'vuex'
import axios from 'axios'
import $ from 'jquery'
export default {
  name: 'Home',
  data(){
    return{
      windowWidth: 0,
      loginShow:true,
      registerShow:false
    }
  },
  components: {

  },
  computed:{
   ...mapState(['token'])
   
  },
  methods:{
      ...mapMutations(['setLogIn','checkLogIn']),
      ...mapActions(['HeaderSelector','actInLogin']),
      getWindowWidth() {
        this.windowWidth = document.documentElement.clientWidth;
      },      
      //************************************Register User********************************************//
      passFocus(){
          document.getElementById("message").style.display = "block";
      },
      passBlur(){
          document.getElementById("message").style.display = "none";
      },
      passkeyUp(){
            var myInput = document.getElementById("password");
            var letter = document.getElementById("letter"); 
            var capital = document.getElementById("capital");
            var number = document.getElementById("number");
            var length = document.getElementById("length");
            var passwordcheck=0;
            // Validate lowercase letters
            var lowerCaseLetters = /[a-z]/g;
            if(myInput.value.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
                passwordcheck++;
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            // Validate capital letters
            var upperCaseLetters = /[A-Z]/g;
            if(myInput.value.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
                passwordcheck++;
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            // Validate numbers
            var numbers = /[0-9]/g;
            if(myInput.value.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
                passwordcheck++;
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            // Validate length
            if(myInput.value.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
                passwordcheck++;
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }

            // validate password - change border color
            if(passwordcheck>=4){
                myInput.classList.remove("invalidborder");
            }else{
                myInput.classList.add("invalidborder");
            }
      },
      register(){ 
        
          
            var email=document.querySelector('#email').value;
            var fname=document.querySelector('#fname').value;
            var lname=document.querySelector('#lname').value;
            var password=document.querySelector('#password').value;
            var password2=document.querySelector('#password2').value;

            var emailUpper = email.toUpperCase();


            //validations
            if(email.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Email is empty!'
                })
            }else if(fname.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'First name is empty!'
                })
            }else if(lname.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Last name is empty!'
                })
            }else if(password.trim()==''){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Password is empty!'
                })
            }else if(password2!=password){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Pasword does not match!'
                })
            }else if(emailUpper.indexOf('@GAFA.CO.NZ')==-1){
                this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Please enter correct email address (ex: ***@gafa.co.nz)'
                })
            }else{
                var form = document.getElementById('form-register');
                axios.post('http://localhost:80/newgafa/src/models/Register.php', new FormData(form))
                //axios.post('http://gafa.co.nz/models/Register.php', new FormData(form))
                .then(res =>{
                    if(res.data.rta=='0'){

                        this.$swal({
                        title: 'success',
                        text: 'successful',
                        type: 'success'
                        }).then(() => {
                            this.$router.push({ path: '/login' });                            
                        })

                    }else if(res.data.rta=='1'){
                        this.$swal({
                            type: 'error',
                            title: 'Error',
                            text: 'connection problem, try again later please'
                        })
                    }else if(res.data.rta=='2'){
                        this.$swal({
                            type: 'error',
                            title: 'Error',
                            text: 'The email address is already exists'
                        })
                    }
                    
                })
            }
      },
      //************************************Finish Register User********************************************//
      //************************************Start Login User********************************************//
      funcLogin(device){
          if(device == 0){
            alert('aca');
            var formmobile = document.getElementById('formLoginMobile'); 
            //var answer;
           axios.post('http://localhost:80/newgafa/src/models/login.php', new FormData(formmobile))
          //axios.post('http://gafa.co.nz/models/login.php', new FormData(form))
          .then(res =>{
            //correct credentials
            if(res.data.rta=='0'){  
              this.actInLogin(res.data.token);
              this.$router.push({ path: '/' });
            }
            //password incorrect
            else if(res.data.rta=='1'){
              this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'Password Incorrect'
              })
            }
            //user does not exist
            else if(res.data.rta=='2'){
              this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'User Does Not Exists'
              })
            }
            else{
              this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'Conection problem'
              })
            }
          })        
          }else if(device == 1){
            var formlaptop = document.getElementById('formLoginLaptop');
            //var answer;
           axios.post('http://localhost:80/newgafa/src/models/login.php', new FormData(formlaptop))
          //axios.post('http://gafa.co.nz/models/login.php', new FormData(form))
          .then(res =>{
            //correct credentials
            if(res.data.rta=='0'){  
              this.actInLogin(res.data.token);
              this.$router.push({ path: '/' });
            }
            //password incorrect
            else if(res.data.rta=='1'){
              this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'Password Incorrect'
              })
            }
            //user does not exist
            else if(res.data.rta=='2'){
              this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'User Does Not Exists'
              })
            }
            else{
              this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'Conection problem'
              })
            }
          })
          }          
          
      },
      goRegister(){
        $('#ontop').animate({left:"50%"},{duration :900});
        this.registerShow = !this.registerShow;
        this.loginShow = !this.loginShow;
      },
      goLogin(){
        $('#ontop').animate({left:"0"},{duration :900});
        this.registerShow = !this.registerShow;
        this.loginShow = !this.loginShow;
      },
      beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth);
    }
  },
  created(){
    this.HeaderSelector(4);
    //var location = '22 main st Boston MA'
        /*axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=-36.850801,174.760045&key=AIzaSyAfFUjrudgDLRH5z7PguZyPhO5m5MIPC6A', 
        {
          params:{
            //address:location
          }
        })
         .then(function(response){
           console.log(response)
         })*/
  },
  mounted() {
    this.$nextTick(function() {
          window.addEventListener('resize', this.getWindowWidth);

          //Init
          this.getWindowWidth();
        }) 
  }
}

</script>


<style>
.home {
  min-height:70vh;
}

.circleButton{
  border-radius: 80px!important;
}
#message {
    display:none;
    background: #f1f1f1;
    color: #000;
    position: relative;
    padding:10px 20px;
    width:20%;
    margin:auto;
    margin-top:-20px;
}
#message p {
    padding: 0px 35px;
    font-size: 13px;
}
.valid {
    color: green;
}
.valid:before {
    position: relative;
    left: -35px;
    content: "\2713";
}
.invalid {
    color: red;
}
.invalidborder {
    border: 1px solid red!important;
    box-shadow: 0px 0px 3px red!important;
}
.invalid:before {
    position: relative;
    left: -35px;
    content: "\00D7";
}
.margins{
  padding: 0px!important;
}
.margins button{
  width: 100%;
  padding-right: 20px!important;
}
/**transition for modals**/
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
/**Resposive Design for laptops*/
.first {
    height: 500px;
    background-color: #ddd;
    background: transparent!important;
}
.ontop {
    height: 300px;
    position: absolute;
    top: 100px;
    right: 0;
    left: 0;
    width: 50%;
}
.aca{
  background-image: url("../assets/login_backgorund.jpg");
  width: 50%;
  height: 503px;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 0 0 0 0!important;
  background-attachment:fixed;
}
.login-modal p{
  color: #A5A5A5;
  font-size: 10px;
}
.login-modal p span{
  cursor: pointer;
  color: #007BFF;
}
.pruebacss{
  border-radius: 20px;
  background: rgb(0, 0, 0, 0.3);

  height: 503px;
}
</style>

    